import { StatisticPart } from "types/business/StatisticPart";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = StatisticPart[];

export const useDefaultObservableStatisticPartArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectStatisticPartArray extends BehaviorSubject<CurrentType> {}
